module.exports = __webpack_public_path__ + "img/icon-general-light.5d647674.svg";